import { AttachmentFieldEnum } from "@/pages/requests/components/attachments/types";
import * as z from "zod";
// import { Base64 } from "js-base64";
import { StringOrArrayBuffer } from "@/utils";

export const DocumentSchema = z.object({
  DocId: z.number().optional(),
  DocTypeId: z.number().optional(),
  ContractorId: z.number().optional(),
  SubContractorId: z.number().optional(),
  DocNameEn: AttachmentFieldEnum.or(z.string()).optional(),
  DocNameAr: z.string().optional(),
  Format: z.string().optional(),
  // FileBase64: z.string().min(1).refine(Base64.isValid).optional(),
  FileBase64: z.string().or(StringOrArrayBuffer),
  FileName: z.string().optional(),
  IsMandatory: z.boolean().optional(),
  TemplateTitle: z.string().optional().or(z.null().optional()),
  TemplatePath: z.string().optional().or(z.null().optional()),
  ApplicationStatusActionRequiredDocumentsId: z.number().optional(),
  Value: z.string().optional(),
});

export const DocumentsResponseSchema = z.object({
  LoaDocuments: z.array(DocumentSchema),
});

export type Document = z.infer<typeof DocumentSchema>;

export type DocumentsResponse = z.infer<typeof DocumentsResponseSchema>;

export interface RequiredDocumentsPayload {
  requestId?: string;
}
